import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { DetalleService, HistoricoProveedorServicio, HistoricoUrgOriServicio } from '../../../core/services/Detalle/detalle.service';
import { HistoricoServicio } from '../../../core/model/detalle-solicitud';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-historicocomponent',
  templateUrl: './historicocomponent.component.html',
  styleUrls: ['./historicocomponent.component.css']
})
export class HistoricocomponentComponent implements OnChanges, OnInit, OnDestroy {

  @Input() idSolicitud;
  @Input() reload;

  statusCode: number;
  requestProcessing = false;
  noData = false;
  mensajeToShow: string;

  requestProcessingUrOri = false;
  noDataUrOri = false;
  mensajeToShowUrOri: string;

  requestProcessingProve = false;
  noDataProve = false;
  mensajeToShowProve: string;



  allHistorico: HistoricoServicio[];
  allHistoricoUrgOri: HistoricoUrgOriServicio[];
  allHistoricoProveedor: HistoricoProveedorServicio[];

  private subscription;
  private subscription_change;
  private subscription_get;
  private subscriptionUrgOri_get;

  isDocoutUser: boolean;
  constructor(
    private toastr: ToastrService,
    private translateService: TranslateService,
    private authService: AuthenticationService,
    private detalleservice: DetalleService) { }


    // region "Initialize"
  ngOnInit() {
    this.SetEnviroment();
    // this.InitLanguage();
    this.getHistorico();
    this.getHistoricoUrgOri();
    this.getHistoricoProveedor();
  }

  InitLanguage() {
    this.subscription = this.translateService.get(['historico'])
        .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
        this.translateService.get(['historico'])
            .subscribe(values => { this.TranslateText(values); });
    });
  }

  TranslateText(values: any) {

  }


  SetEnviroment() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });
}

ngOnChanges(changes: SimpleChanges) {
  const name: SimpleChange = changes.name;
  if (changes.reload) {
    const recarga = changes.reload.firstChange;
    if (!recarga) {
      this.getHistorico();
      this.getHistoricoUrgOri();
      this.getHistoricoProveedor();
   }
}
}
// endregion
getHistorico() {
  this.preProcessProfile('Recuperando datos históricos de la solicitud');
  this.subscription_get = this.detalleservice.getHistorico(this.idSolicitud)
      .subscribe(historico => {
        this.noData = false;
        this.allHistorico = new Array();
        this.allHistorico = historico;
        if (this.allHistorico.length <= 0) {
            this.noData = true;
        }

        this.requestProcessing = false;

      },
          errorCode => {
            this.muestraError(errorCode, '');
          });
}

  // 🥑🥑 SRR mostrar el historico de cambios ori y ur
getHistoricoUrgOri() {
  this.preProcessProfile('Recuperando datos históricos de la solicitud');
  this.subscriptionUrgOri_get = this.detalleservice.getHistoricoUrgOri(this.idSolicitud)
      .subscribe(historico => {
        this.noDataUrOri = false;
        this.allHistoricoUrgOri = new Array();
        this.allHistoricoUrgOri = historico;
        if (this.allHistoricoUrgOri.length <= 0) {
            this.noDataUrOri = true;
        }

        this.requestProcessingUrOri = false;

      },
          errorCode => {
            this.muestraError(errorCode, '');
          });
}

    // 🥑🥑 SRR mostrar el historico de proveedores
getHistoricoProveedor() {
  this.preProcessProfile('Recuperando datos históricos proveedores de la solicitud');
  this.subscriptionUrgOri_get = this.detalleservice.getHistoricoProveedor(this.idSolicitud)
      .subscribe(historico => {
        this.noDataProve = false;
        this.allHistoricoProveedor = new Array();
        this.allHistoricoProveedor = historico;
        if (this.allHistoricoProveedor.length <= 0) {
            this.noDataProve = true;
        }

        this.requestProcessingProve = false;

      },
          errorCode => {
            this.muestraError(errorCode, '');
          });
  }
  
preProcessProfile(mensaje: string) {
  this.mensajeToShow = mensaje;
  this.statusCode = null;
  this.requestProcessing = true;
  this.requestProcessingUrOri = true;
}


muestraError(errorCode: HttpErrorResponse, mensaje: string) {
  this.statusCode = errorCode.status;
  // si hay errores extendidos por ADMIn se muestra  uno u otro

  if (mensaje.length <= 0 || !mensaje) {
      if (errorCode.error) {
          mensaje = errorCode.error.Message;
      } else {
          mensaje = errorCode.message;
      }
  }
  this.toastr.error('Se ha encontrado un error: ' + mensaje, 'Error servidor');
}


  ngOnDestroy() {

    if (!this.subscription == null) { this.subscription.unsubscribe(); }
    if (!this.subscription_change == null) { this.subscription_change.unsubscribe(); }
    if (!this.subscription_get == null) { this.subscription_get.unsubscribe(); }
    if (!this.subscriptionUrgOri_get == null) { this.subscriptionUrgOri_get.unsubscribe(); }
    this.detalleservice = null;
    this.authService = null;
    this.toastr = null;
}


}
